<hero-insight-icons [items]="items"
  (switched)="onSwitch($event)"></hero-insight-icons>